import React, { useState } from 'react';
import { Recommendations } from '../../react-recommendations/src';

type RecommendationsWithFallbackProps = {
    fallbackTitle: string;
    fallbackProduct: string;
    fallbackType?: string;
    forceFallback: boolean;
    showVerticalFilter: boolean;
} & React.ComponentProps<typeof Recommendations>;

function isEmpty(str) {
    return !str || 0 === str.length;
}

const RecommendationsWithFallback: React.FC<RecommendationsWithFallbackProps> = ({
    fallbackTitle,
    fallbackProduct,
    fallbackType = 'recommend',
    title,
    product,
    forceFallback,
    showVerticalFilter,
    ...props
}) => {
    const [fallback, setFallback] = useState(forceFallback);

    if (fallback && !isEmpty(fallbackProduct)) {
        return (
            <>
                <Recommendations
                    {...props}
                    title={fallbackTitle}
                    product={fallbackProduct}
                    type={fallbackType}
                    useFallBackProduct={true}
                    showVerticalFilter={false}
                />
            </>
        );
    }
    return (
        <Recommendations
            {...props}
            title={title}
            product={product}
            onEmpty={() => setFallback(true)}
            showVerticalFilter={showVerticalFilter}
        />
    );
};

export default RecommendationsWithFallback;
